(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessibility"]) return;
  try {
    
'use strict';

class Feature {

	static GROUP = 'group';
	static INDIVIDUAL = 'individual';

	granularity;
	textUpdater;
	enabled;

	constructor(granularity, textUpdater) {
		if (granularity != Feature.GROUP && granularity != Feature.INDIVIDUAL) {
			throw 'Invalid feature granularity: ' + granularity;
		}
		this.granularity = granularity;
		this.textUpdater = textUpdater;
		this.enabled = false;
	}

	get isEnabled() {
		return this.enabled;
	}

	setEnabled(enable) {
		if (this.enabled != enable) {
			this.enabled = enable;
			return true;
		}
		return false;
	}

	update(textContainers) {
		if (this.granularity == Feature.GROUP) {
			this.textUpdater(textContainers, this.enabled);
		}
		else if (this.granularity == Feature.INDIVIDUAL) {
			for (var i in textContainers) {
				this.textUpdater(textContainers[i], this.enabled);
			}
		}
	}

}

var textAssist = {

	features: {},
	observer: new MutationObserver(function(mutations, observer) {
		for (var i in mutations) {
			var added = mutations[i].addedNodes;
			for (var j in added) {
				textAssist.updateText(added[j]);
			}
		}
	}),

	anyEnabled : function() {
		for (var feature in this.features) {
			if (this.features[feature].isEnabled) return true;
		}
		return false;
	},

	enabledFeatures : function() {
		var enabled = [];
		for (var feature in this.features) {
			if (this.features[feature].isEnabled) {
				enabled.push(feature);
			}
		}
	},

	isEnabled : function(feature) {
		return this.features[feature].isEnabled;
	},

	disabledFeatures : function() {
		var disabled = [];
		for (var feature in this.features) {
			if (!this.features[feature].isEnabled) {
				disabled.push(feature);
			}
		}
	},

	updateObserver : function() {
		if (this.anyEnabled()) {
			this.observer.observe(document, {
				childList: true,
				subtree : true,
			});
		}
		else {
			this.observer.disconnect();
		}
	},

	addFeature : function(feature, granularity, textUpdater) {
		if (this.features[feature] !== undefined) {
			this.toggleFeature(feature, false);
		}
		this.features[feature] = new Feature(granularity, textUpdater);
		if (navigator.cookieEnabled && Cookies.get(feature) == 'enabled') {
			this.toggleFeature(feature, true);
		}
	},

	addSimpleFeature : function(feature) {
		this.addFeature(feature, Feature.GROUP, function(textContainers, enabled) {
			if (enabled) {
				for (var i in textContainers) {
					textContainers[i].classList.add(feature);
				}
			}
			else {
				for (var i in textContainers) {
					textContainers[i].classList.remove(feature);
				}
			}
		});
	},

	toggleFeature : function(feature, enable) {
		if (this.features[feature].setEnabled(enable)) {
			this.updateTextFor(document, feature);
			this.updateObserver();
			if (navigator.cookieEnabled) {
              if (enable) {
                  Cookies.set(feature, 'enabled');
              }
              else {
                  Cookies.remove(feature);
              }
			}
		}
	},

	/* This update accounts for all features, and only needs to occur when elements are
	 * added to a page after page load or last feature toggle.
	*/
	updateText : function(parent) {
		var containers = this.getTextContainers(parent);
		for (var feature in this.features) {
			this.features[feature].update(containers);
		}
	},

	/* This update accounts for only the specified feature, and occurs when an
	 * individual feature is turned on or off.
	*/
	updateTextFor : function(parent, feature) {
		this.features[feature].update(this.getTextContainers(parent));
	},

	getTextContainers : function(parent) {
		var containers = [];
		function getNodes(parent) {
			var added = false;
			for (var i in parent.childNodes) {
				var node = parent.childNodes[i];
				// nodeType 3 = text node
				// /\S/ tests to ensure the node actually has text
				if (!added && node.nodeType == 3 && /\S/.test(node.nodeValue)) {
					containers.push(parent);
					added = true;
				}
				else {
					getNodes(node);
				}
			}
		}

		getNodes(parent);
		return containers;
	},
};

// Add jQuery pseudo for focusable elements
if (jQuery) {
	jQuery.extend(jQuery.expr[':'], {
		"focusable": function(element) {
			return $(element).is('a, button, :input, [tabindex]');
		}
	});
}

textAssist.addSimpleFeature('high-contrast');

/*
textAssist.addFeature('text-assist', Feature.GROUP, function(textContainers, enabled) {
	var classes = ['high-contrast', 'large-text', 'wide-spacing'],
		$containers = $(textContainers); 
    if (enabled) {
		for (var i in classes) {
			$containers.addClass(classes[i]);
		}
	}
	else {
		for (var i in classes) {
			$containers.removeClass(classes[i]);
		}
	}
});
*/
                                                             
$('#text-assist-container').on('keyup', function(e) {
	if (e.key == 'Enter') {
		$('#text-assist').click();
	}
});

$('#text-assist').on('change', function(e) {
	var enable = this.checked;
	textAssist.toggleFeature('high-contrast', enable);
});
                                                         
$('#text-assist').prop('checked', textAssist.isEnabled('high-contrast'));
                                                                              

  } catch(e) { console.error(e); }
})();
})();
